require('./dist/validate');
module.exports = 'ui.validate';



//////////////////
// WEBPACK FOOTER
// ./~/angular-ui-validate/index.js
// module id = 136
// module chunks = 0